// Messages for operator/Customers (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.customers.head': 'Customers — Operator',
  'operator.customers.title': 'Customers',
  'operator.customers.subtitle': 'Companies you ship for',
  'operator.customers.add': 'Add customer',
  'operator.customers.col.name': 'Name',
  'operator.customers.col.code': 'Code',
  'operator.customers.col.contact': 'Contact',
  'operator.customers.col.staff': 'Staff',
  'operator.customers.col.active': 'Active',
  'operator.customers.empty': 'No customers found.',
  'operator.customers.staff': '{count} staff',
  'operator.customers.shipments': '{count} shipments',
}

export const zhTW = {
  'operator.customers.head': '客戶 — 操作端',
  'operator.customers.title': '客戶',
  'operator.customers.subtitle': '你所承運的公司',
  'operator.customers.add': '新增客戶',
  'operator.customers.col.name': '名稱',
  'operator.customers.col.code': '代碼',
  'operator.customers.col.contact': '聯絡人',
  'operator.customers.col.staff': '人員',
  'operator.customers.col.active': '活躍',
  'operator.customers.empty': '找不到客戶。',
  'operator.customers.staff': '{count} 名人員',
  'operator.customers.shipments': '{count} 件貨件',
}
